import { ProgressSpinner } from "primereact/progressspinner";
import { classNames } from "primereact/utils";

import type { LoadingProps } from "./types-loading";

/** `ProgressSpinner` do Prime com tamanho (`p-progressspinner-<size>` no tema) e rótulo acessível; quem já mostra o texto passa `aria-hidden`. */
export function Loading({
  size = "md",
  label = "Carregando",
  testId,
  className,
  strokeWidth = "4",
  ...rest
}: LoadingProps) {
  return (
    <ProgressSpinner
      aria-label={label}
      data-testid={testId}
      strokeWidth={strokeWidth}
      className={classNames(`p-progressspinner-${size}`, className)}
      {...rest}
    />
  );
}
Loading.displayName = "Loading";
